import { BaseClientType, ClientStepProps } from '../../types';
import { JSX } from 'react';
import PartyList from '../../../parties/partyList';

/**
 * Related parties for natural person or legal entity
 */
const RelatedPartiesStep = <T extends BaseClientType>({
  client,
}: ClientStepProps<T>): JSX.Element => {
  return <PartyList parties={client.parties} />;
};

export default RelatedPartiesStep;
